import { Inline } from "PFComponents/containers";
import { Typography } from "PFComponents/typography";
import { Activity } from "PFCore/types";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";

type ActivityParentProps = {
  parentActivity: Activity;
};

export const ActivityParent = ({ parentActivity }: ActivityParentProps) => {
  const { t } = useTranslation();

  return (
    <Inline data-qa-id="ActivityParent" spread alignItems="center">
      <Typography variant="bodyBold">{t("engagement")}</Typography>
      <Link to={`/activities/${parentActivity.id}`}>
        <Typography tag="span" variant="bodyBold" title={parentActivity.name} textOverflow="break">
          {parentActivity.name}
        </Typography>
      </Link>
    </Inline>
  );
};
